import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import "./boxStyle.css";
import type { MediaImage } from "./ModelMediaContent/ImageInformation";

export type ModelMediaViewProps = {
  modal: boolean;
  nestedModal: boolean;
  closeAll: boolean;
  img?: MediaImage;
  toggle: () => void;
  toggleNested: () => void;
  toggleAll?: () => void;
  handleImageSelected?: (image: MediaImage) => void;
  handleConfirmImageMedia: () => void;
  MediaBrowser: React.ReactNode;
};

const ModelMediaView = ({
  modal,
  nestedModal,
  closeAll,
  img,
  toggle,
  toggleNested,
  handleConfirmImageMedia,
  MediaBrowser,
}: ModelMediaViewProps) => {
  return (
    <div>
      <Button onClick={toggle}>
        <span>Or Select From Media Files</span>
      </Button>

      <Modal
        isOpen={modal}
        toggle={toggle}
        size="lg"
        style={{ maxWidth: "1600px", width: "80%" }}
      >
        <ModalHeader toggle={toggle}>
          <span className="text-primary">
            Select an existing picture from Media Files
          </span>
        </ModalHeader>

        <ModalBody>
          {MediaBrowser}

          {/* Nested confirm modal */}
          <Modal
            isOpen={nestedModal}
            toggle={toggleNested}
            onClosed={closeAll ? toggle : undefined}
          >
            <ModalHeader>
              <span className="text-primary">
                Are you sure to select this picture?
              </span>
            </ModalHeader>

            <ModalBody>
              <div className="container text-center">
                <div className="box-img">
                  {img?.secure_url ? (
                    <img src={img.secure_url} alt={img.filename} />
                  ) : null}
                </div>
                <h4 className="text-center text-primary img-title">
                  {img?.filename}
                </h4>
              </div>
            </ModalBody>

            <ModalFooter>
              <Button color="success" onClick={handleConfirmImageMedia}>
                Yes
              </Button>
              <Button color="secondary" onClick={toggleNested}>
                Pick Another Picture
              </Button>
            </ModalFooter>
          </Modal>
          {/* end nested modal */}
        </ModalBody>

        <ModalFooter>
          {img?.secure_url ? (
            <Button color="success" onClick={toggleNested}>
              Last Selected Picture
            </Button>
          ) : null}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModelMediaView;
